type SetContractNumberAction = {
  payload: {
    contractNumber: string;
  };
  type: 'SET_CONTRACT_NUMBER';
};

export const SET_CONTRACT_NUMBER: SetContractNumberAction = {
  payload: {
    contractNumber: '',
  },
  type: 'SET_CONTRACT_NUMBER',
};

type SetSignedContractAction = {
  payload: {
    signedContract: Uint8Array;
  };
  type: 'SET_SIGNED_CONTRACT';
};

export const SET_SIGNED_CONTRACT: SetSignedContractAction = {
  payload: {
    signedContract: new Uint8Array(),
  },
  type: 'SET_SIGNED_CONTRACT',
};

export type Action = SetContractNumberAction | SetSignedContractAction;
